import { motion } from "framer-motion";

function SkeletonLine({ w, tone = "bg-[#0A0B0D]/15" }) {
  return <div className={`h-2 rounded-full ${tone}`} style={{ width: w }} />;
}

function Chip({ children, className, testId }) {
  return (
    <motion.div
      data-testid={testId}
      className={`absolute z-20 border border-[#FF5500]/40 bg-[#0A0B0D]/90 px-3 py-1.5 backdrop-blur-sm ${className}`}
      animate={{ y: [0, -8, 0] }}
      transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
    >
      <span className="font-mono-ind text-[10px] font-semibold uppercase tracking-[0.2em] text-[#FF5500]">
        {children}
      </span>
    </motion.div>
  );
}

export function PackMockup({ testId = "pack-mockup" }) {
  return (
    <div data-testid={testId} className="relative mx-auto w-full max-w-sm sm:max-w-md">
      <div className="spotlight absolute -inset-20" />

      {/* back guide cover */}
      <div className="absolute inset-x-8 top-10 bottom-[-6px] rotate-[-8deg] rounded-sm border border-white/10 bg-[#14171b]">
        <div className="absolute left-0 top-0 h-full w-3 bg-[#FF5500]/80" />
      </div>
      <div className="absolute inset-x-4 top-5 bottom-[-3px] rotate-[-3deg] rounded-sm border border-white/10 bg-[#1b1f26]">
        <div className="absolute left-0 top-0 h-full w-2 bg-white/15" />
      </div>

      {/* front document */}
      <div className="relative rounded-sm border border-white/20 bg-[#F5F2EA] p-6 shadow-2xl shadow-black/70 sm:p-8">
        <div className="flex items-center justify-between border-b-2 border-[#0A0B0D] pb-3">
          <span className="font-display text-2xl font-extrabold uppercase tracking-wide text-[#0A0B0D]">
            Sitebound
          </span>
          <span className="h-3 w-3 bg-[#FF5500]" />
        </div>
        <div className="mt-5 space-y-3">
          <div className="font-mono-ind text-[10px] uppercase tracking-[0.25em] text-[#FF5500]">
            Resume — Construction
          </div>
          <div className="h-4 w-3/4 rounded-sm bg-[#0A0B0D]/80" />
          <div className="h-2 w-1/3 rounded-full bg-[#0A0B0D]/40" />
          <div className="grid grid-cols-[1fr_2fr] gap-4 pt-3">
            <div className="space-y-2 border-r border-[#0A0B0D]/10 pr-3">
              <SkeletonLine w="90%" />
              <SkeletonLine w="70%" />
              <SkeletonLine w="80%" />
              <div className="mt-3 h-1.5 w-full bg-[#FF5500]" />
              <SkeletonLine w="85%" />
              <SkeletonLine w="60%" />
            </div>
            <div className="space-y-2">
              <SkeletonLine w="100%" />
              <SkeletonLine w="95%" />
              <SkeletonLine w="88%" />
              <SkeletonLine w="100%" />
              <SkeletonLine w="72%" />
              <div className="pt-2" />
              <SkeletonLine w="96%" />
              <SkeletonLine w="84%" />
            </div>
          </div>
        </div>
        <div className="absolute bottom-5 right-5 rotate-[-10deg] border-2 border-[#FF5500] px-2 py-1">
          <span className="font-mono-ind text-[9px] font-bold uppercase tracking-[0.2em] text-[#FF5500]">
            Site Ready
          </span>
        </div>
      </div>

      <Chip testId="mockup-chip-components" className="-left-2 top-8 sm:-left-8">
        95 Files · 10 Sections
      </Chip>
      <Chip testId="mockup-chip-download" className="-right-2 top-1/3 sm:-right-10">
        Instant Download
      </Chip>
      <Chip testId="mockup-chip-price" className="-left-1 bottom-10 sm:-left-6">
        $49 AUD — Once
      </Chip>
    </div>
  );
}

export function MiniDoc({ label, lines = 4 }) {
  return (
    <div className="border border-white/10 bg-[#14171b] p-4">
      <div className="font-mono-ind mb-3 text-[9px] uppercase tracking-[0.25em] text-[#FF5500]">
        {label}
      </div>
      <div className="space-y-2">
        {Array.from({ length: lines }).map((_, i) => (
          <div
            key={i}
            className="h-1.5 rounded-full bg-white/12"
            style={{ width: `${88 - i * 11}%` }}
          />
        ))}
      </div>
    </div>
  );
}
